module.exports = __webpack_public_path__ + "img/Frey.04fe6da5.jpg";